import { Model } from '@/services/api/lib'

export default class StateMachine extends Model {
  resource () {
    return 'settings/v1/settings/workflows/list'
  }

  primaryKey () {
    return 'workflow_name'
  }

  can (transition, from) {
    if (!this.transitions) {
      return false
    }

    if (!(transition in this.transitions)) {
      return false
    }

    const action = this.transitions[transition]

    return !!action['from'].includes(from)
  }

  cannot (transition, from) {
    return !this.can(transition, from)
  }

  async getDefault () {
    return this.find(await this.getDefaultName())
  }

  async getDefaultName () {
    const { data } = await this.request({
      method: 'GET',
      url: 'settings/v1/settings/workflows/defaults/order'
    })

    return data
  }
}
